import { apiConfig } from '@/config'

import type { ClientPdfDocument } from './client-pdf-document'
import { proposalPdfGenerator, triggerPdfDownload } from './ProposalPdfGenerator'

function pdfUrl(): string {
  const base = apiConfig.baseUrl.replace(/\/$/, '')
  if (base) return `${base}/proposals/pdf`
  return '/api/proposals/pdf'
}

export async function requestProposalPdf(document: ClientPdfDocument): Promise<{
  blob: Blob
  filename: string
}> {
  try {
    const response = await fetch(pdfUrl(), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/pdf',
      },
      body: JSON.stringify({ document }),
    })

    if (response.ok) {
      const blob = await response.blob()
      const header = response.headers.get('Content-Disposition')
      const match = header?.match(/filename="([^"]+)"/)
      return { blob, filename: match?.[1] ?? 'proposta.pdf' }
    }
  } catch {
    // Fall through to the local jsPDF engine (Vite without API, offline).
  }

  const local = proposalPdfGenerator.generateFromClient(document)
  return { blob: local.blob, filename: local.filename }
}

export async function downloadClientPdf(document: ClientPdfDocument): Promise<{
  filename: string
  blob: Blob
}> {
  const result = await requestProposalPdf(document)
  triggerPdfDownload(result.blob, result.filename)
  return result
}
